import styled from 'styled-components';

export const TextInputStyle = styled.div<{
  width?: string;
  expandable?: boolean;
}>`
  width: ${(p) => p.width ?? '100%'};
  position: relative;

  textarea {
    resize: ${(props) => (props.expandable ? 'vertical' : 'none')};
    width: 100%;

    box-sizing: border-box;
    height: 47px;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.palette.divider};
    border-radius: 7px;
    background-color: ${({ theme }) => theme.palette.background.default};

    color: ${({ theme }) => theme.palette.text.primary};
    font-size: 16px;
    line-height: 22px;

    padding: 10px;
    margin: 5px 0;

    &::placeholder {
      color: ${({ theme }) => theme.palette.text.disabled};
    }

    &:hover {
      background-color: ${({ theme }) => theme.palette.background.default};
    }

    &:focus {
      box-shadow: ${({ theme }) => theme.shadows[24]};
      background-color: ${({ theme }) => theme.palette.background.default};
    }

    &.error {
      border: 1px solid ${({ theme }) => theme.palette.error.main};
      background-color: ${({ theme }) => theme.palette.background.default};
    }

    &.warning {
      border: 1px solid ${({ theme }) => theme.palette.warning.main};
      background-color: ${({ theme }) => theme.palette.background.default};
    }

    &.success {
      border: 1px solid ${({ theme }) => theme.palette.success.main};
      background-color: ${({ theme }) => theme.palette.background.default};
    }

    ${({ theme }) => theme.breakpoints.down('sm')} {
      background-color: ${({ theme }) => theme.palette.background.paper};
    }
  }
`;

export const ErrorMessage = styled.p`
  color: ${({ theme }) => theme.palette.error.main};
  font-size: 12px;
  margin: -6px 8px 0;
`;

export const WarningMessage = styled.p`
  color: ${({ theme }) => theme.palette.warning.main};
  font-size: 12px;
  margin: -6px 8px 0;
`;

export const SuccessMessage = styled.p`
  color: ${({ theme }) => theme.palette.success.main};
  font-size: 12px;
  margin: -6px 8px 0;
`;

export const CharCount = styled.span`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 14px;
`;
